module.exports = __webpack_public_path__ + "img/logo.6014063b.jpg";